import Modal from "@via/components/modal.tsx";
import { ButtonColor } from "@via/utils/constants.tsx";
import { type FC } from "react";
import { useDeleteDataSource } from "@via/pages/data/data-connections/data-connections.api.tsx";

interface DeleteBookmarkItemModalProps {
  bookmarkedItem: {
    name: string;
    id: number;
  } | null;
  setBookmarkedItem: (
    bookmarkedItem: { name: string; id: number } | null
  ) => void;
}

const DeleteBookmarkItemModal: FC<DeleteBookmarkItemModalProps> = ({
  bookmarkedItem,
  setBookmarkedItem,
}) => {
  const { mutateAsync: deleteDataSource, isPending: isDeleteLoading } =
    useDeleteDataSource();

  return (
    <Modal
      open={!!bookmarkedItem}
      setOpen={() => {
        setBookmarkedItem(null);
      }}
      title="Delete Bookmarked Item"
      confirmText="Delete"
      confirmButtonColor={ButtonColor.Red}
      isConfirmLoading={isDeleteLoading}
      onConfirm={() => deleteDataSource(bookmarkedItem?.id.toString())}>
      <div className="flex flex-col py-2 text-sm leading-6 text-slate-600 md:py-3 lg:py-4">
        <p>
          Are you sure you want to delete{" "}
          <span className="font-semibold">{bookmarkedItem?.name}</span>?
        </p>
      </div>
    </Modal>
  );
};

export default DeleteBookmarkItemModal;
